import { render, staticRenderFns } from "./changePoint.vue?vue&type=template&id=b951eeb4&scoped=true"
import script from "./changePoint.vue?vue&type=script&lang=js"
export * from "./changePoint.vue?vue&type=script&lang=js"
import style0 from "./changePoint.vue?vue&type=style&index=0&id=b951eeb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b951eeb4",
  null
  
)

export default component.exports